import React, {Component} from 'react';
import {Card, Col, Row} from 'reactstrap';
import {formatDate} from "../../../util/datehelpers";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';
const labelStatus = ["Not Started", "Working", "", "", "", "", "", "", "", "Submitted", "Enrolled"];

export default class Messages extends Component {

  constructor(props) {
    super(props);
    this.marquee = null;
  }

  render() {
    return (
      <Card style={{padding: 10, minHeight: 200, maxHeight: 300, borderRadius: 10}}>
        <Row>
          <Col sm={12}>
            <div style={{fontSize: 11, width: "100%"}}>
              <h4>Messages</h4>
              {/*<table style={{fontSize: 10, width: "100%"}}>*/}
              <marquee ref={(ref) => this.marquee = ref} width={"100%"} style={{height: 250}} direction={"up"}
                       loop={"-1"}
                       onMouseOver={this.marquee && this.marquee.stop()}
                       onMouseOut={this.marquee && this.marquee.start()} behavior="scroll"
                       scrollamount="2" scrolldelay="85">
                {this.props.data.map((leader, index) => {
                    return <div key={index} style={{marginBottom: 3}}>
                      {`${formatDate(new Date(leader.dated))} - ${leader.message}`}
                    </div>
                  }
                )}
              </marquee>
            </div>
          </Col>
        </Row>
      </Card>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Messages/Messages.js